/**
 * The distinct subsidiary ids that `walletIds` belong to, in first-seen order.
 *
 * Mirrors api-svc's internal-transfer guard: wallets that are unknown or have no
 * subsidiary are not counted, so more than one id here means the movement spans
 * subsidiaries and must be categorized as an Intercompany Transfer, not an
 * Internal Transfer.
 */
export function distinctWalletSubsidiaryIds(
  walletIds: ReadonlyArray<string | null | undefined>,
  wallets: ReadonlyArray<{ id: string; subsidiaryId?: string | null }> | null | undefined
): string[] {
  const subsidiaryByWallet = new Map((wallets ?? []).map((w) => [w.id, w.subsidiaryId]));
  const subsidiaryIds = new Set<string>();
  for (const walletId of walletIds) {
    const subsidiaryId = walletId ? subsidiaryByWallet.get(walletId) : undefined;
    if (subsidiaryId) {
      subsidiaryIds.add(subsidiaryId);
    }
  }
  return [...subsidiaryIds];
}
